/** Same path as vite.config.js `server.proxy` — must stay in sync. */
export const REALTIME_DEV_PROXY_PREFIX = "/__ecotransferz_realtime";

const REALTIME_PROD_HOST_RE =
  /^https?:\/\/realtime\.ecotransferz\.com\/?$/i;

/**
 * Base URL for realtime REST + SignalR.
 * In dev, if `.env` still points at production realtime, use the Vite proxy so
 * `/secret/public-key` and hubs are same-origin (avoids CORS when `.env.local`
 * overrides `.env.development`).
 */
export function getRealtimeBaseUrl() {
  const raw = (import.meta.env.VITE_SOCKET_URL || "").trim();
  if (!raw) {
    return import.meta.env.DEV ? REALTIME_DEV_PROXY_PREFIX : "";
  }

  if (raw.startsWith("/")) {
    const path = raw.replace(/\/+$/, "");
    return path || REALTIME_DEV_PROXY_PREFIX;
  }

  const normalized = raw.replace(/\/+$/, "");
  if (import.meta.env.DEV && REALTIME_PROD_HOST_RE.test(normalized)) {
    return REALTIME_DEV_PROXY_PREFIX;
  }

  return normalized;
}
